import React from "react";

function NotFound() {
  return (
    <div className="NotFound">
      <h1>404</h1>
      <h3>Nada para fazer aqui!</h3>
    </div>
  )
}

export default NotFound;
